import P13ReportComponent from 'components/Report/P13Report';
import PermissionGuard from 'components/Global/PermissionGuard';

const P13Report = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<P13ReportComponent />
		</PermissionGuard>
	);
};

export default P13Report;
